'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'rv';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = ['M48 80l0 214.1L121.9 368l6.1 0c13.4-10 30-16 48-16s34.6 6 48 16l160 0 0-112 0-72 0-24 24 0 16 0 80 0 8.3 0 47.7 0 0-80L48 80zm48 48l192 0 0 128L96 256l0-128z', 'M224 0L384 0l0 32 200 0 24 0 0 24 0 128 0 24-24 0-10.6 0 57.4 45.1 9.2 7.2 0 11.7 0 120 0 24-24 0-41.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16l-9.6 0-153.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-6.8 .8-13.4 2.4-19.6L95 409 7 321l-7-7L0 304 0 56 0 32l24 0 200 0 0-32zM432 256l124.8 0-61.1-48L432 208l0 48zM384 368l0-112 0-72 0-24 24 0 16 0 80 0 8.3 0 47.7 0 0-80L48 80l0 214.1L121.9 368l6.1 0c13.4-10 30-16 48-16s34.6 6 48 16l160 0zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 128l0 128L96 256l0-128 192 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;